import React from 'react';
import { Grid, Typography, List, ListItem, ListItemText } from '@mui/material';
import { accomplishments } from './TembeaData';

const Accomplishments = () => (
    <Grid item xs={12} md={8}>
        <Typography variant="h5" gutterBottom textAlign='center' fontWeight='bold'>
            BEADS TEMBEA ACADEMY SPECIAL ACCOMPLISHMENTS:
        </Typography>
        <List>
            {accomplishments.map((item, index) => (
                <ListItem alignItems="flex-start" key={index}>
                    <ListItemText
                        primary={`${index + 1}. ${item.title}`}
                        secondary={item.description}
                        primaryTypographyProps={{ fontWeight: 'bold', fontSize: '1.25rem' }}
                        secondaryTypographyProps={{ component: 'div' }}
                    />
                </ListItem>
            ))}
        </List>
    </Grid>
);

export default Accomplishments;
